import React from "react";

export const SendButton = ({ ...props }) => {
  return (
    <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
      <path
        d="M15.167 1.416L7.375 9.208M15.167 1.416l-4.959 14.167-2.833-6.375L1 6.374l14.167-4.958z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
